import { render, staticRenderFns } from "./screctKeyDetail.vue?vue&type=template&id=de48c894&scoped=true&"
import script from "./screctKeyDetail.vue?vue&type=script&lang=js&"
export * from "./screctKeyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de48c894",
  null
  
)

export default component.exports